import IndexPage from './IndexPage'
import DetailPage from './detail/DetailPage'
import DeviceGroup from './detail/DeviceGroup'

export default [
  {
    path: '/bridges',
    name: 'bridges',
    component: IndexPage,
  },
  {
    path: '/bridges/:serialNumber',
    name: 'bridges.detail',
    component: DetailPage,
    children: [
      {
        path: 'device-group',
        name: 'bridges.detail.deviceGroups',
        component: DeviceGroup
      },
      {
        path: 'device-group/:uuid',
        name: 'bridges.detail.deviceGroup',
        component: DeviceGroup,
        props: true
      }
    ]
  }
]
